import React from 'react';
import { colors } from '@mui/material';
import { Avatar, AvatarGroup, Box, Container, Card, CardMedia, CardContent, CardActions } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';
import { SimPopupCardDetails } from 'components/SimPopupCardDetails';
import { SimSlider, SimSliderContainer } from './SimSlider';
import SimPolygon from 'components/svg/shapes/SimPolygon';

import autismPic from 'assets/images/10.webp';
import autismPuzzlePic from 'assets/images/10.webp';
import childDevelopmentPic from 'assets/images/child_development_orange_385x280.webp';
import occupationalTherapyPic from 'assets/images/4.webp';
import abaTherapyPic from 'assets/images/8.webp';
import splTherapyPic from 'assets/images/1.webp';
import feedingTherapyPic from 'assets/images/33.webp';
import physicalTherapyPic from 'assets/images/6.webp';

const options = [
	{
		category: 'Development',
		media: childDevelopmentPic,
		title: 'Child Development 101',
		tutor: 'Dr. Praveen Kumar, Dev. Pediatrician',
		date: 'Mon, 19 Jan, 2023',
		time: '18:25:32 GMT',
		duration: '90 minutes',
		fee: 'Free',
		location: 'Online',

		audience: 'For Parents',
		summary:
			'60 – 90 minute community session on brain formation stages, developmental areas, risk factors and regression.',

		users: [
			'https://hendersonfamilymagazine.com/wp-content/uploads/2022/03/ParentProfile-Feature.jpg',
			'https://t4.ftcdn.net/jpg/00/44/50/63/360_F_44506382_EazIxapwkcV9FFRkYQXsGutxRRBTPJcT.jpg',
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc=',
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM=',
			'https://media.istockphoto.com/id/533347509/photo/close-up-of-a-mature-man-smiling-at-the-camera.jpg?s=612x612&w=0&k=20&c=HT8P9FAQsBaAZ-iL_UEDB1M4xxsz4dk258l9XxPhMgM='
		]
	},
	{
		category: 'Autism',
		media: autismPic,
		title: 'Autism 101',
		tutor: 'Dr. Erica Jowett-Hirst, BCBA',

		date: 'Mon, 19 Jan, 2023',
		time: '18:25:32 GMT',
		duration: '90 minutes',
		fee: 'Free',
		location: 'Online',

		audience: 'For Parents',
		summary:
			'90 – 120 minute interactive session to understand autism - prevalence, diagnosis, symptoms, causes & how to handle it right.',

		users: [
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc=',
			'https://media.istockphoto.com/id/533347509/photo/close-up-of-a-mature-man-smiling-at-the-camera.jpg?s=612x612&w=0&k=20&c=HT8P9FAQsBaAZ-iL_UEDB1M4xxsz4dk258l9XxPhMgM=',
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM='
		]
	},
	{
		category: 'ABA Therapy',
		media: abaTherapyPic,
		title: 'Challenging Behaviors',
		tutor: 'Dr. Erica Jowett-Hirst, BCBA',

		date: 'Mon, 19 Jan, 2023',
		time: '18:25:32 GMT',
		duration: '90 minutes',
		fee: 'Free',
		location: 'Online',

		audience: 'For Parents',
		summary:
			'90 – 120 minute interactive session to understand a variety of hard-to-manage behavior patterns & early intervention for the child’s development journey.',

		users: [
			'https://t4.ftcdn.net/jpg/00/44/50/63/360_F_44506382_EazIxapwkcV9FFRkYQXsGutxRRBTPJcT.jpg',
			'https://media.istockphoto.com/id/533347509/photo/close-up-of-a-mature-man-smiling-at-the-camera.jpg?s=612x612&w=0&k=20&c=HT8P9FAQsBaAZ-iL_UEDB1M4xxsz4dk258l9XxPhMgM=',
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc=',
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM=',
			'https://hendersonfamilymagazine.com/wp-content/uploads/2022/03/ParentProfile-Feature.jpg'
		]
	},
	{
		category: 'Speech & Language',
		media: splTherapyPic,
		title: 'Communication',
		tutor: 'Dr. Erica Jowett-Hirst, BCBA',

		date: 'Mon, 19 Jan, 2023',
		time: '18:25:32 GMT',
		duration: '90 minutes',
		fee: 'Free',
		location: 'Online',

		audience: 'For Parents',
		summary:
			'90 – 120 minute interactive session to understand communication issues in is autism, and how parents can help their child’s development journey.',

		users: [
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc=',
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM='
		]
	},

	{
		category: 'Feeding Therapy',
		media: feedingTherapyPic,
		title: 'Picky Eating',
		tutor: 'Dr. Erica Jowett-Hirst, BCBA',

		date: 'Mon, 19 Jan, 2023',
		time: '18:25:32 GMT',
		duration: '90 minutes',
		fee: 'Free',
		location: 'Online',

		audience: 'For Parents',
		summary:
			'90 – 120 minute interactive session to understand picky eating behavior patterns, and how to handle them right with proven techniques.',

		users: [
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM=',
			'https://hendersonfamilymagazine.com/wp-content/uploads/2022/03/ParentProfile-Feature.jpg',
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc='
		]
	},

	{
		category: 'Autism',
		media: autismPuzzlePic,
		title: 'Stimming',
		tutor: 'Dr. Erica Jowett-Hirst, BCBA',

		date: 'Mon, 19 Jan, 2023',
		time: '18:25:32 GMT',
		duration: '90 minutes',
		fee: 'Free',
		location: 'Online',

		audience: 'For Parents',
		summary:
			'90 – 120 minute interactive session to understand how schooling for special needs child works differently, and how to get it right.',

		users: [
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc=',
			'https://media.istockphoto.com/id/533347509/photo/close-up-of-a-mature-man-smiling-at-the-camera.jpg?s=612x612&w=0&k=20&c=HT8P9FAQsBaAZ-iL_UEDB1M4xxsz4dk258l9XxPhMgM=',
			'https://t4.ftcdn.net/jpg/00/44/50/63/360_F_44506382_EazIxapwkcV9FFRkYQXsGutxRRBTPJcT.jpg',
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM=',
			'https://hendersonfamilymagazine.com/wp-content/uploads/2022/03/ParentProfile-Feature.jpg'
		]
	},

	{
		category: 'Occupational Therapy',
		media: occupationalTherapyPic,
		title: 'Play Skills',
		tutor: 'Dr. Erica Jowett-Hirst, BCBA',

		date: 'Mon, 19 Jan, 2023',
		time: '18:25:32 GMT',
		duration: '90 minutes',
		fee: 'Free',
		location: 'Online',

		audience: 'For Parents',
		summary:
			'90 – 120 minute interactive session to understand toilet training for all age-groups in autism, and how to best cope as a caregiver',

		users: [
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM=',
			'https://hendersonfamilymagazine.com/wp-content/uploads/2022/03/ParentProfile-Feature.jpg',
			'https://media.istockphoto.com/id/525949883/photo/smiling-woman.jpg?s=612x612&w=0&k=20&c=drPuUoVZMA3h0WuDpcmwWlAdIBL31WQUvZNe9IPi8wc='
		]
	},
	{
		category: 'Physical Therapy',
		media: physicalTherapyPic,
		title: 'Physical Activity',
		tutor: 'Dr. Praveen Kumar, Dev. Pediatrician',

		date: 'Mon, 19 Jan, 2023',
		time: '18:25:32 GMT',
		duration: '90 minutes',
		fee: 'Free',
		location: 'Online',

		audience: 'For Parents',
		summary:
			'90 – 120 minute interactive session to ask anything you need to know from experts who have studied and helped thousands of families.',

		users: [
			'https://t4.ftcdn.net/jpg/00/44/50/63/360_F_44506382_EazIxapwkcV9FFRkYQXsGutxRRBTPJcT.jpg',
			'https://media.istockphoto.com/id/1097618664/photo/mature-smiling-woman.jpg?s=612x612&w=0&k=20&c=nqvODQTensirt_7ALNBm5J2ixmbOl0OkUYwDDgqghUM=',
			'https://hendersonfamilymagazine.com/wp-content/uploads/2022/03/ParentProfile-Feature.jpg'
		]
	}
];

const SimFeaturedEventsSlider = () => {
	const theme = useTheme();

	return (
		<SimSliderContainer>
			<SimSlider>
				{options.map((item, idx) => (
					<Box key={idx} padding={{ xs: 1, sm: 1, md: 1, lg: 1 }}>
						<Box
							display={'block'}
							width={1}
							height={1}
							sx={{
								textDecoration: 'none',
								transition: 'all .2s ease-in-out',
								'&:hover': {
									transform: `translateY(-${theme.spacing(1 / 2)})`
								}
							}}>
							<Box
								component={Card}
								width={1}
								minHeight={{ xs: '750px', sm: '950px', md: '80vw', lg: '50vw' }}
								height={{ xs: 230, sm: '84vw', md: '80vw', lg: '50vw' }}
								display={'flex'}
								flexDirection={'column'}
								sx={{ backgroundImage: 'none' }}
								paddingBottom={3}>
								<CardMedia
									title={item.title}
									image={item.media}
									sx={{
										position: 'relative',
										height: { xs: 240, sm: 340, md: 280 },
										overflow: 'hidden'
									}}>
									<SimPolygon sx={{ bottom: 0 }} />

									<Box
										display={'flex'}
										justifyContent={'space-between'}
										position={'absolute'}
										top={0}
										padding={2}
										width={1}
										zIndex={2}>
										<Box
											padding={1}
											paddingX={1.5}
											bgcolor={'background.paper'}
											boxShadow={5}
											borderRadius={6}
											border={1}
											borderColor={'#bfbfbf'}>
											<SimTypography sx={{ fontWeight: 600 }}>{item.category}</SimTypography>
										</Box>
									</Box>
								</CardMedia>
								<CardContent>
									<SimTypography variant={'h6'} gutterBottom align={'left'} sx={{ fontWeight: 700 }}>
										{item.title}
									</SimTypography>
									<Box
										borderBottom={1}
										borderColor={alpha(theme.palette.text.primary, 0.3)}
										paddingBottom={1}
										display={'flex'}
										flexDirection={{ xs: 'column', md: 'row' }}
										justifyContent={'space-between'}
										marginY={0}>
										<SimTypography variant={'subtitle1'} color='text.secondary'>
											{item.date}
										</SimTypography>
										<SimTypography variant={'subtitle1'} color='text.secondary'>
											{item.time}
										</SimTypography>
										<SimTypography variant={'subtitle1'} color='text.secondary'>
											({item.duration})
										</SimTypography>
									</Box>

									<Box
										paddingBottom={1}
										display={'flex'}
										flexDirection={'row'}
										justifyContent={'space-between'}
										marginY={0}>
										<SimTypography variant={'subtitle1'} color='text.secondary'>
											{item.fee}
										</SimTypography>
										<SimTypography variant={'subtitle1'} color='text.secondary'>
											{item.location}
										</SimTypography>
									</Box>

									<SimTypography gutterBottom align={'left'} sx={{ fontWeight: 300 }}>
										{item.summary}
									</SimTypography>

									<Box display={'flex'} alignItems={'center'} marginY={2}>
										<Box
											component={'svg'}
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											stroke='currentColor'
											width={24}
											height={24}
											marginRight={1}>
											<path d='M12 14l9-5-9-5-9 5 9 5z' />
											<path d='M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z' />
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												strokeWidth={2}
												d='M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222'
											/>
										</Box>
										<SimTypography variant={'subtitle1'} color='text.secondary'>
											{item.tutor}
										</SimTypography>
									</Box>

									<Box marginTop={2} display={'flex'} justifyContent={'space-between'}>
										<AvatarGroup max={4}>
											{item.users.map(u => (
												<Avatar key={u} src={u} />
											))}
										</AvatarGroup>
										<Box display={'flex'} alignItems={'center'}>
											<Box
												component={'svg'}
												width={20}
												height={20}
												xmlns='http://www.w3.org/2000/svg'
												viewBox='0 0 20 20'
												fill='currentColor'
												color={colors.yellow[700]}
												marginRight={1}>
												<path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
											</Box>
											<SimTypography sx={{ fontWeight: 700 }}>5.0</SimTypography>
										</Box>
									</Box>
								</CardContent>
								<Box flexGrow={1} />

								<CardActions
									sx={{
										justifyContent: 'center'
									}}>
									<Box
										display={'flex'}
										flexDirection={'column'}
										width={1}
										justifyContent={'center'}
										alignItems={'center'}>
										<Container spacing={1} width={1}>
											<Box display={'flex'} flexDirection={'row'} justifyContent={'center'}>
												<SimButton
													variant={'contained'}
													href={'/contact'}
													color='primary'
													size='large'
													sx={{ marginY: '0px', paddingY: '0px' }}>
													<SimTypography
														variant='buttonText'
														fontSize={16}
														sx={{ marginY: '0px', paddingY: '0px' }}>
														Schedule Appointment
													</SimTypography>
												</SimButton>
											</Box>

											<Box marginTop={2} />
											<Box
												width={1}
												display={'flex'}
												flexDirection={'row'}
												justifyContent={'center'}>
												<Box>
													<SimPopupCardDetails title={item.title} />
												</Box>
											</Box>
										</Container>
									</Box>
								</CardActions>
							</Box>
						</Box>
					</Box>
				))}
			</SimSlider>
		</SimSliderContainer>
	);
};

export default SimFeaturedEventsSlider;
